var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("admin-nav-menu", { attrs: { "active-item": "misc" } }),
      _vm._v("\n    Дополнительно\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }